import gql from 'graphql-tag';

export const FOOTER_MENU_LINK_FRAGMENT = gql`
  fragment footerMenuLink on FooterMenuLinkType {
    createdAt
    updatedAt
    id
    text
    url
  }
`;
